(() => {
  const enabled = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  const selector = '.header > .header__inline-menu, .header > .header__icons';
  let active = null;
  let bounds = null;
  const reset = () => {
    if (active) {
      active.style.removeProperty('--nav-magnet-x');
      active.style.removeProperty('--nav-magnet-y');
    }
    active = null;
    bounds = null;
  };
  document.addEventListener('pointerover', event => {
    if (!enabled.matches || event.pointerType !== 'mouse') return;
    const group = event.target.closest(selector);
    if (!group || group === active) return;
    reset();
    active = group;
    bounds = group.getBoundingClientRect();
  }, { passive: true });
  document.addEventListener('pointermove', event => {
    if (!active || !bounds || !enabled.matches || event.pointerType !== 'mouse') return;
    const x = Math.max(-1, Math.min(1, (event.clientX - bounds.left - bounds.width / 2) / (bounds.width / 2)));
    const y = Math.max(-1, Math.min(1, (event.clientY - bounds.top - bounds.height / 2) / (bounds.height / 2)));
    active.style.setProperty('--nav-magnet-x', `${(x * 4).toFixed(2)}px`);
    active.style.setProperty('--nav-magnet-y', `${(y * 2).toFixed(2)}px`);
  }, { passive: true });
  document.addEventListener('pointerout', event => {
    if (active && (!event.relatedTarget || !active.contains(event.relatedTarget))) reset();
  }, { passive: true });
  document.addEventListener('pointercancel', reset, { passive: true });
  document.addEventListener('keydown', reset);
  document.addEventListener('shopify:section:unload', reset);
  window.addEventListener('scroll', reset, { passive: true });
  window.addEventListener('resize', reset, { passive: true });
  window.addEventListener('blur', reset);
  enabled.addEventListener('change', reset);
})();
